export const warningDialogTexts = {
  headerText: 'Есть несохранённые данные, сбросить?',
  bodyText: 'Вы уверены, что хотите сбросить несохранённые данные и покинуть страницу?',
  actionText: 'Сбросить',
} as const;
